<template>
  <div class="swiper">
    <swiper v-if="swiperList.length > 0" ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in swiperList" :key="index"><img :data-url="item.targetUrl" :class="item.targetUrl ? 'point' : ''" :src="handleUrl(item.imageUrl)" alt=""></swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
const jsonp = require("jsonp");
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  data() {
    return {
      swiperList: [],
      swiperOptions:{
        //显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        //自动轮播
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        speed: 1000,
        //开启循环模式
        loop: true,
        on:{
          click: function(e){
            if (e.target.getAttribute('data-url')) {
              window.open(e.target.getAttribute('data-url'))
            }
          }
        }
      }
    }
  },
  mounted() {
    this.getSwiperList()
  },
  methods: {
    getSwiperList() {
      jsonp(`${this.$etturl}banners/list.do?r=${Math.random()}`, {
        r: Math.random()
      }, (err, res) => {
        if (!err) {
          this.swiperList = res.data
          if (this.swiperList.length <=1) {
            this.swiperOptions.loop = false
          }
        }
      })
    },
    // 将图片地址替换为https
    handleUrl(url) {
      let urlArr = url.split('://')
      let newUrl = ''
      if(urlArr[0] == "http"){
        newUrl = "https://" + urlArr[1]
      } else {
        newUrl = url
      }
      return newUrl
    }
  },
  components: {
    Swiper,
    SwiperSlide
  }
}
</script>
<style lang="scss" scoped>
.swiper {
  .point {
    cursor: pointer;
  }
  .banner-img {
    width: 100%;
    height: 100%;
    // height: 568px;
    display: block;
  }
}
</style>
<style lang="scss">
.swiper {
  width: 100%;
  // height: 568px;
  .swiper-container {
    width: 100%;
    img {
      width: 100%;
      // height: 568px;
    }
  }
}
</style>